<template>
    <div class="home _page">

        <div class="main-banner">
            <l-carousel :height='winH | toPx'>
                <l-carousel-item v-for='(item, index) of bannerConf' :key='index'>
                    <l-banner v-bind='item'></l-banner>
                </l-carousel-item>
            </l-carousel>
            <l-mouse class="mouse"></l-mouse>
        </div>


        <div class="_container scheme">

            <l-block-head title='全面解决方案'></l-block-head>
            <l-row>
                <div class="scheme-item">
                    <div style="text-align: center"><img src="@/assets/u14.svg"/></div>
                    <h4 class="title">
                        芯片SoC
                    </h4>
                    <p class="content">
                        低功耗微传感SoC芯片DN9188集成了Boost DCDC、双光路恒流驱动电路、光电流信号调理器、ADC、自研RISC-V
                        CPU内核（32位，支持多种语言），多路UART、SPI、I2C等丰富的通讯外设，降低误报率，减小体积、降低成本的同时，具有高集成度度、高抗干扰、高可靠性和超低功耗的特点，是全球首创的光电颗粒物浓度探测器的单芯片解决方案、烟雾探测器的单芯片解决方案、光学近距离传感的单芯片解决方案，应用于火灾报警、智能家电、汽车电子、医疗电子、智慧工业等领域产品。产品工艺：eFlash_0.11um_ULL
                    </p>
                </div>
            </l-row>
            <l-row :gutter='100'>
                <l-col :span='6' v-for='item of scheme' :key='item.title'>

                    <div class="scheme-item">
                        <div class="icon">
                            <l-img :src='item.icon'></l-img>
                        </div>
                        <h4 class="title">
                            {{ item.title }}
                        </h4>
                        <p class="content">
                            {{ item.content }}
                        </p>
                    </div>

                </l-col>
            </l-row>

            <button class="more">
                更多期待
            </button>

        </div>


        <div class="case _container">
            <l-block-head title='经典案例'></l-block-head>

            <l-row :gutter='6'>
                <l-col :span='8' v-for='(care, index) of cases' :key="index">
                    <div v-for='(item, index) of care' :key='index' :class='item.type'>
                        <l-img-card :src='item.src' :title='item.title'></l-img-card>
                    </div>
                </l-col>
            </l-row>
        </div>

        <l-sub-banner class="sub-banner" :src='subBanner' title='中科德诺 · 物联网低功耗微传感芯片SoC' sub-title='DNG · AIoT SoC .' slogan='— 一家的人工智能物联网传感企业 —'></l-sub-banner>


        <div class="partner _container">
<!--            <l-block-head title='合作伙伴'></l-block-head>-->

<!--            <div class='logo-row'>-->
<!--                <div class='logo-col' v-for='(item, index) of partners' :key='index'>-->
<!--                    <div class="logo-card">-->
<!--                        <l-img :src='item'></l-img>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->

        </div>


    </div>
</template>

<script>
import {
    subBanner,
    bannerConf,
    partners,
    scheme,
    cases,
} from '../model/home'

export default {
    name: 'home',
    data() {
        return {
            bannerConf,
            subBanner,
            scheme,
            cases,
            partners,
            winH: 400
        }
    },
    filters: {
        toPx(num) {
            return `${num}px`
        }
    },
    created() {
        let time;
        const _this = this;

        function getWinH() {
            clearTimeout(time)
            _this.winH = document.body.clientHeight
        }

        getWinH()
        window.addEventListener('resize', () => time = setTimeout(getWinH, 100))
    }
}
</script>

<style lang="scss" scoped>
.home {
    background: $color_3;
}

.scheme-item {
    margin-bottom: 60px;


    .icon {
        $size: 90px;
        margin: 0 auto 60px;
        width: $size;
        height: $size;
    }

    .title {
        margin-bottom: 28px;
        text-align: center;
        @include font_sub_title;
    }

    .content {
        @include font_content;
        @include text_overflow(4);
        overflow: hidden;
        height: 62px;
    }

}

.more {
    $w: 160px;
    $h: 40px;
    margin: 30px auto 60px;
    display: block;
    width: $w;
    height: $h;
    line-height: $h;
    background: $main_color;
    border-radius: $h/2;
    color: $font_color_light;
    text-align: center;
    transition: all .5s;

    &:hover {
        transform: translateY(-4px);
        @extend ._main_color_shadow;
    }
}

.case {
    $h: 618px;
    $interval: 6px;
    padding-bottom: 180px;

    .half {
        height: ($h - $interval ) / 2;
    }

    .half + .half {
        margin-top: $interval;
    }

    .full {
        height: $h;
    }

}

.partner {
    margin-bottom: 160px;

    $interval: 16px;

    .logo-row {
        margin: 0 $interval/-2;
        width: 100%;

    }

    .logo-col {
        box-sizing: border-box;
        padding: 0 $interval/2;
        display: inline-block;
        width: 20%;
    }

    .logo-card {
        @extend ._def_border;

        box-sizing: border-box;
        margin-bottom: 16px;
        height: 100px;
        background: $color_bg;
    }
}

.main-banner {
    position: relative;

    .mouse {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 20px;
        margin: auto;
        z-index: 99;
    }

}

</style>
